import { COLORS } from '@btime/constants'
import React from 'react'

import { SubItem, SubItemsWrapper } from '../../../../../components/structure/SubItems'
import { getQueryParam } from '../../../../../utils/helpers/url'
import { useIsDraggingItem } from '../../../../../components/dnd/DndHandler'
import ConditionsLabel from './conditions/ConditionsLabel'
import QuestionsList from './QuestionsList'
import Separator from '../../../../../components/helpers/Separator'

const Item = ({ label, index, color, parentReference, question, displayConditions }) => {
  const [open, setOpen] = React.useState(getQueryParam('startsClosed') !== 'true')

  return (
    <div>
      <Separator weight={2} />
      <SubItem noLine>
        <ConditionsLabel
          displayConditions={displayConditions}
          question={question}
          index={index}
          open={open}
          toggle={() => setOpen(!open)}
        />
      </SubItem>

      {open && (
        <>
          <Separator weight={2} />

          <QuestionsList
            questions={question.children}
            parentReference={parentReference}
            displayConditions={displayConditions}
            isSubItems
          />

          <Separator weight={2} />
        </>
      )}
    </div>
  )
}

const LogicControl = ({ question, hide }) => {
  const isDraggingQuestion = useIsDraggingItem(question.reference)

  if (!question.childDisplayConditions || isDraggingQuestion) return false

  return (
    <SubItemsWrapper>
      {question.childDisplayConditions.map((conditions, index) => (
        <Item
          key={index}
          index={index}
          question={question}
          questions={question.children}
          displayConditions={conditions}
          color={COLORS.green}
          parentReference={question.reference}
        />
      ))}

      <Separator weight={2} />
    </SubItemsWrapper>
  )
}

export default LogicControl
